import { firstToUpperCase } from '../../utilities/string';
// Reserved properties - cannot be used directly, use mapped ReservedPropKeyMappings values instead
var ReservedPropKeys;
(function (ReservedPropKeys) {
    ReservedPropKeys["Class"] = "class";
})(ReservedPropKeys || (ReservedPropKeys = {}));
// Property keys to be used in place of reserved properties
var TransformedPropKeys;
(function (TransformedPropKeys) {
    TransformedPropKeys["ClassName"] = "className";
})(TransformedPropKeys || (TransformedPropKeys = {}));
var EventListeners;
(function (EventListeners) {
    EventListeners["OnClick"] = "onClick";
})(EventListeners || (EventListeners = {}));
// Maps reserved property names to a usable, non-reserved property name to be used instead
const ReservedPropKeyMappings = {
    [ReservedPropKeys.Class]: TransformedPropKeys.ClassName,
};
/**
 * Adds and transforms specific props onto passed HTMLElement
 *
 * @param {HTMLElement} element Element to add props onto
 * @param {PropTypes} props Props to add onto element
 * @returns {HTMLElement} Element with props added onto it
 */
export const parseProps = (element, props) => {
    for (const [key, value] of Object.entries(props)) {
        // If a reserved property is passed in, throw error
        // Not mapping property to correct type since reserved properties can cause errors in logic processing
        if (Object.values(ReservedPropKeys).includes(key)) {
            throw new Error(`Using reserved attribute name "${ReservedPropKeys[firstToUpperCase(key)]}". Please use "${ReservedPropKeyMappings[key]}" instead.`);
        }
        // Checks if a key is its reserved counterpart to do any data transformation needed
        // Processes className property
        if (key === TransformedPropKeys.ClassName && typeof value === 'string') {
            const classNames = value.split(' ');
            classNames.forEach((className) => element.classList.add(className));
        }
        else if (key === EventListeners.OnClick) {
            if (typeof value === 'function') {
                element.addEventListener('click', value);
            }
            else {
                throw new Error(`Value for onClick event listener is not of type "function". Passed type: "${typeof value}"`);
            }
        }
        else if (typeof value === 'string') {
            // If a property doesn't match a reserved blob, add attribute onto element
            element.setAttribute(key, value);
        }
    }
    return element;
};
